
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"34","height":"34","rx":"3","fill":"#FEF0D4"}}),_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M12.569 19.85l1.84-5.716h1.656l-1.857 5.716h-1.64zm-.736-5.716l-1.473 2.418c-.384.629-.602.958-.702 1.35H9.64c.034-.502-.05-1.13-.05-1.475l-.167-2.293H6.647l-.034.157c.72 0 1.138.33 1.255 1.021l.535 4.538h1.707l3.446-5.716h-1.723zm12.797 5.7l-.05-.848h-2.058l-.418.848h-1.79l3.246-5.7h2.191l.552 5.7H24.63zm-.184-3.36c-.017-.424-.033-.99 0-1.335h-.017c-.1.283-.535 1.13-.719 1.555l-.619 1.256h1.439l-.084-1.476zm-6.658 3.533c-1.154 0-1.94-.346-2.476-.66l.787-1.13c.501.267.886.565 1.773.565.284 0 .569-.063.72-.33.233-.376-.051-.565-.703-.91l-.318-.189c-.954-.612-1.372-1.193-.92-2.198.284-.644 1.037-1.146 2.291-1.146.854 0 1.673.345 2.142.69l-.904.99c-.451-.345-.836-.518-1.271-.518-.351 0-.619.125-.703.298-.167.314.05.534.552.832l.385.22c1.154.691 1.439 1.398 1.138 2.073-.502 1.146-1.473 1.413-2.493 1.413zm9-5.103h-.067v-.408h.168c.1 0 .15.031.15.11 0 .078-.05.11-.117.11l.117.172h-.084l-.117-.173h-.067l.017.189zm.084-.236c.05 0 .1 0 .1-.063 0-.047-.05-.062-.1-.062h-.084v.125h.084zm0 .393c-.218 0-.385-.157-.385-.361 0-.22.184-.361.385-.361.2 0 .385.14.385.36 0 .22-.184.362-.385.362zm0-.675a.294.294 0 00-.301.298c0 .173.117.298.3.298a.294.294 0 00.302-.298.294.294 0 00-.301-.298z","fill":"#005596"}}),_c('path',{attrs:{"d":"M30 21.364l-26.229.017V25h26.23v-3.636z","fill":"#F7AA0F"}}),_c('path',{attrs:{"d":"M30 7.636H3.771v4.3h26.23v-8z","fill":"#005596"}})])])
          )
        }
      }
    